import React from 'react';
import { useDispatch } from 'react-redux';
import { openModal } from '@/Store/Slices/ModalSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';

const MultipleUnpublishMerchants = ({checked}) => {
  const dispatch = useDispatch();

  const handleMultipleAction = () => {
    dispatch(openModal({
      modalType: 'multiple-coupon-modal',
      modalProps: {
        ids: checked,
        url: 'public.merchants.multi.unpublish',
        text: 'Do you want to unpublish selected merchants?',
      }
    }));
  }

  return (
    <button onClick={handleMultipleAction} className={'mr-3'} data-tip="Multiple unpublish merchants" >
      <FontAwesomeIcon
        rotation={180}
        color={'red'}
        size={'lg'}
        icon={solid('arrow-right-long')}/>
    </button>
  );
};

export default MultipleUnpublishMerchants;
